import React, { Component } from 'react';
import PropTypes from 'prop-types';

const parseName = name => {
  const regex = /([\[\]]*([^\[\]]+)\]*)/g;
  return name.match(regex).map(node => node.replace(/[\[\]]/g, ''))
};

const setRouteValue = (object, route, value) => {
  const obj = { ...object };
  let endpoint = obj;

  route.forEach((node, index) => {
    if (index === route.length - 1) {
      endpoint[node] = value;
    } else {
      endpoint[node] = endpoint[node] || {};
      endpoint = endpoint[node];
    }
  });

  return obj;
}

const getRouteValue = (object, route) => {
  let endpoint = { ...object };

  route.find((node, index) => {
    if (index === route.length - 1) {
      endpoint = endpoint[node];
    } else {
      endpoint[node] = endpoint[node] || {};
      endpoint = endpoint[node];
    }
  });

  return endpoint;
}

export default class Form extends Component {
  static childContextTypes = {
    onChange: PropTypes.func,
    errors: PropTypes.object,
    getFormValue: PropTypes.func,
    values: PropTypes.object
  };

  static defaultProps = {
    defaults: {}
  };

  state = this.props.defaults ? this.props.defaults : {};

  getChildContext() {
    return {
      onChange: ::this.handleChange,
      errors: this.props.errors,
      getFormValue: ::this.getValue,
      values: this.state
    }
  }

  handleChange(name, value) {
    if (!name) return;

    const route = parseName(name);
    const val = setRouteValue(this.state, route, value);

    this.setState({ [route[0]]: val[route[0]] }, () => {
      if (this.props.onChange) this.props.onChange(this.state, name, val);
    });
  }

  getValue(name) {
    if (!name) return;
    const route = parseName(name);
    return getRouteValue(this.state, route);
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.props.onSubmit) this.props.onSubmit(this.state);
  }

  componentDidMount() {
    if (this.props.onLoad) this.props.onLoad(this);
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.defaults && nextProps.defaults || this.props.overrideValues) {
      this.setState(nextProps.defaults);
    }
  }

  onKeyPress() {}

  render() {
    const { onKeyPress } = this.props;

    return (
      <form className="Form" onSubmit={::this.handleSubmit} onKeyPress={typeof onKeyPress === "function" ? (event) => onKeyPress(event) : this.onKeyPress}>
        {this.props.children}
      </form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/form.js